import {DRVBundGlobals} from '@zs21/drv-bund-common-ilias-utils';

export const ENV_VARS = {
    DASHBOARD_REF_ID: '',
    FEEDBACK_DATA_COLLECTION_CONFIG: '',
    VOUCHER_DATATABLE_URL: '',
    EDUCATION_CATALOGUE_CATEGORY_IMAGES_URL: '',
    VIRTUAL_MEETING_ROOMS_URL: '',
    LIST_CONTENTS_URI: '',
};
DRVBundGlobals.EXPECTED_ENV_VARS = Object.keys(ENV_VARS);
for (const key of Object.keys(ENV_VARS)) {
    ENV_VARS[key] = DRVBundGlobals.ENV_VARS.get(key);
}
